// extracted by mini-css-extract-plugin
module.exports = {"hide":"AdminPanelLayoutStyles_hide__1ywaC","childrenComponentStyle":"AdminPanelLayoutStyles_childrenComponentStyle__2G27m"};